import auth from './authState'

const API_BASE = import.meta.env.VITE_API_BASE || '/api'

async function request(url, options = {}) {
  const { skipAuthExpiry = false, ...fetchOptions } = options

  const headers = {
    ...(fetchOptions.headers || {})
  }
  if (auth.token.value) {
    headers.Authorization = `Bearer ${auth.token.value}`
  }

  const response = await fetch(`${API_BASE}${url}`, {
    ...fetchOptions,
    headers
  })

  if (response.status === 401 && !skipAuthExpiry) {
    // 统一走登录态的 logout()，清除 token 后界面会立即回到登录卡片
    auth.logout()
    throw new Error('登录已过期，请重新登录')
  }

  if (!response.ok) {
    const text = await response.text()
    let message = text
    try {
      const data = JSON.parse(text)
      if (data && typeof data.message === 'string' && data.message) {
        message = data.message
      }
    } catch (e) {
      // 非 JSON 响应，直接使用原始文本
    }
    throw new Error(message || `请求失败: ${response.status}`)
  }

  const contentType = response.headers.get('content-type')
  if (contentType && contentType.includes('application/json')) {
    return response.json()
  }
  return response
}

export function submitHazard(formData) {
  return request('/submit', {
    method: 'POST',
    body: formData
  })
}

export function loginAdmin(credentials) {
  return request('/login', {
    // 登录接口的 401 表示账号或密码错误，不能当作登录过期处理
    skipAuthExpiry: true,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  })
}

export function fetchHazards(params = {}) {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value)
    }
  })
  return request(`/list?${query.toString()}`)
}

export function updateHazard(data) {
  return request('/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}

export function exportHazards(params = {}) {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value)
    }
  })
  return request(`/export?${query.toString()}`)
}

export function getImageUrl(id, index = 0) {
  const token = auth.token.value
  return `${API_BASE}/image?id=${id}&index=${index}&token=${encodeURIComponent(token || '')}`
}

export function getVideoUrl(id, index = 0) {
  const token = auth.token.value
  return `${API_BASE}/video?id=${id}&index=${index}&token=${encodeURIComponent(token || '')}`
}

export function getDownloadUrl(id, index = 0) {
  const token = auth.token.value
  return `${API_BASE}/download?id=${id}&index=${index}&token=${encodeURIComponent(token || '')}`
}

export function markSynced(ids) {
  return request('/sync', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids })
  })
}

export function deleteHazards(ids) {
  return request('/delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids })
  })
}
